<template >
  <div class="mainbody">
    <div style="padding: 16px 32px 16px 0px">
      <span class="title">分类列表</span>
      <el-button type="primary" size="small" style="float: right" @click="addInfo()">新建</el-button>
    </div>
    <div class="aLine"></div>
    <div class="tableInfo">
      <el-table :data="data_list" style="width: 100%; margin-bottom: 20px" row-key="id" default-expand-all :tree-props="{ children: 'son', hasChildren: 'hasChildren' }">
        <el-table-column prop="order" label="排序" min-width="1"> </el-table-column>
        <el-table-column prop="title" label="名称" min-width="1"> </el-table-column>
        <el-table-column prop="statusStr" label="状态" min-width="1"> </el-table-column>
        <el-table-column prop="shop_count" label="企业数量" min-width="1"> </el-table-column>
        <el-table-column prop="createTime" label="创建时间" min-width="1"> </el-table-column>
        <el-table-column prop="operating" label="操作" min-width="1" align="left">
          <template slot-scope="scope">
            <el-button class="operateText" size="mini" type="text" @click="editInfo(scope.row)">编辑</el-button>
            <el-button class="operateText" size="mini" type="text" @click="deleteInfo(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as Utils from '@/utils/utils.js'
import { URL_PATH } from '@/config/config'

export default {
  components: {},
  data() {
    return {
      urlPath: URL_PATH,
      data_list: [] //数据列表
    }
  },
  activated() {
    this.getList()
  },
  deactivated() {},
  created() {
    this.getList()
  },
  methods: {
    getList: function () {
      this.$api
        .shopTypeList({
          token: localStorage.getItem('token')
        })
        .then(({ data }) => {
          this.data_list = data.Data
          this.data_list.forEach(info => {
            info.statusStr = info.status == 'Y' ? '启用' : '未启用'
            info.createTime = Utils.dateFormat(info.create_time * 1000)
            if (info.son) {
              info.son.forEach(info => {
                info.statusStr = info.status == 'Y' ? '启用' : '未启用'
                info.createTime = Utils.dateFormat(info.create_time * 1000)
              })
            }
          })
        })
        .catch(({ error }) => {})
    },
    // 新建活动
    addInfo() {
      this.$router.push({
        path: '/wxapp/enterprise_classify_add'
      })
    },
    // 编辑
    editInfo(row) {
      this.$router.push({
        path: '/wxapp/enterprise_classify_add',
        query: {
          id: row.id
        }
      })
    },
    // 删除
    deleteInfo(row) {
      this.$confirm('是否删除此分类?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      })
        .then(() => {
          this.$api
            .delShopType({
              token: localStorage.getItem('token'),
              id: row.id
            })
            .then(({ data }) => {
              this.getList()
            })
            .catch(({ error }) => {})
        })
        .catch(() => {})
    }
  }
}
</script>

<style lang="less" scoped>
.mainbody {
  // overflow: hidden;
  background-color: #ffffff;
  border-radius: 5px;
  padding-bottom: 58px;
}
.mainbody .title {
  font-family: PingFang SC;
  font-style: normal;
  font-weight: 800;
  font-size: 16px;
  line-height: 24px;
  color: rgba(0, 0, 0, 0.85);
  padding: 16px 32px;
}
.mainbody .aLine {
  background-color: #e9e9e9;
  height: 1px;
}
.mainbody .tableInfo {
  box-sizing: border-box;
  margin-left: 32px;
  margin-right: 32px;
}
.operateText {
  font-size: 14px;
}
</style>


// WEBPACK FOOTER //
// src/components/enterprise/enterpriseClassify.vue